export const configureSEO = () => {
  const isDev =
    process.env.REACT_APP_ENV === "dev" ||
    window.location.hostname === "dev.cancopetroleum.ca";

  // Prod stays indexable — do not change meta tags.
  if (!isDev) {
    return;
  }

  const directive =
    process.env.REACT_APP_ROBOTS_META ||
    "noindex, nofollow, noarchive, nosnippet, noimageindex";

  [
    "robots-meta",
    "googlebot-meta",
    "google-extended-meta",
    "gptbot-meta",
    "chatgpt-user-meta",
    "claudebot-meta",
    "perplexitybot-meta",
    "bytespider-meta",
    "ccbot-meta",
  ].forEach((id) => {
    const meta = document.getElementById(id);
    if (meta) {
      meta.setAttribute("content", directive);
    }
  });
};
